import React from 'react';

const ClockIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path strokeLinecap="round" d="M12 7v5l3 2" />
  </svg>
);
const CheckIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);
const GearIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="12" r="3.2" />
    <path strokeLinecap="round" d="M12 3.5v2.6m0 9.8v2.6M3.5 12h2.6m9.8 0h2.6M5.8 5.8l1.9 1.9m8.6 8.6l1.9 1.9m0-12.4l-1.9 1.9M7.7 16.3l-1.9 1.9" />
  </svg>
);
const BoxIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l9-5 9 5v8l-9 5-9-5V8zm9-5v18m-9-13l9 5 9-5" />
  </svg>
);
const TruckIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 6h11v10H3zM14 9h4l3 3v4h-7zM7 19a2 2 0 100-4 2 2 0 000 4zm11 0a2 2 0 100-4 2 2 0 000 4z" />
  </svg>
);
const XIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
    <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
  </svg>
);
const DotIcon = () => (
  <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
  </svg>
);

const STATUS = {
  pending: { label: 'Pendente', icon: ClockIcon, classes: 'bg-honey-50 text-honey-700 border-honey-200' },
  paid: { label: 'Pago', icon: CheckIcon, classes: 'bg-sage-50 text-sage-700 border-sage-200' },
  processing: { label: 'Em produção', icon: GearIcon, classes: 'bg-dusk-50 text-dusk-700 border-dusk-200' },
  ready: { label: 'Pronto', icon: BoxIcon, classes: 'bg-caramel-50 text-caramel-700 border-caramel-200' },
  delivered: { label: 'Entregue', icon: TruckIcon, classes: 'bg-sage-50 text-sage-700 border-sage-200' },
  cancelled: { label: 'Cancelado', icon: XIcon, classes: 'bg-clay-50 text-clay-700 border-clay-200' },
};

const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1);

const StatusChip = ({ status, size = 'md' }) => {
  const key = status ? String(status).toLowerCase() : '';
  const config = STATUS[key] || {
    label: capitalize(key || '—'),
    icon: DotIcon,
    classes: 'bg-cream-100 text-ink-soft border-cream-200',
  };
  const Icon = config.icon;

  const sizeClasses =
    size === 'sm' ? 'px-2 py-0.5 text-[11px] gap-1' : 'px-2.5 py-1 text-xs gap-1.5';

  return (
    <span
      aria-label={config.label}
      className={`inline-flex items-center whitespace-nowrap rounded-full border font-semibold ${sizeClasses} ${config.classes}`}
    >
      <Icon />
      {config.label}
    </span>
  );
};

export default StatusChip;
